module.exports = __webpack_public_path__ + "img/10.31ef7ca8.png";